import MasterService from "./MasterService";

const CommissionService = {
    ...MasterService,

    getCommissionPointList(params: any) {
        return this.post('/commissionPoint/getCommissionPointList', params)
    },
    getCommissionPointDetails(params: any) {
        return this.post('/commissionPoint/getCommissionPointDetails', params)
    },

}


export default CommissionService;